import React, { useState, useRef, useEffect } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";

import { api } from "../../../../../../../../utility/AxiosInceptor";
import { Toast } from "primereact/toast";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import AddAgentDetail from "./Dialogs/add_agent_detail";
import AddCellPhoneModelDialog from "./Dialogs/add_cell_phone_model_dialog";
import { useNavigate } from "react-router-dom";

export default function CellPhoneSingleUpload({
  inventoryIdSelected,
  makeModel,
  identifierTypeSelected,
  isUpload,
  rowData,
  setUpdateInventory,
  unit,
  isFromhome,
  model,
  setAddUnits,
}) {
  let ref = useRef(null);
  const loginRes = localStorage.getItem("userData");
  let navigate = useNavigate();
  const parseLoginRes = JSON.parse(loginRes);
  const [
    add_cellphone_model_dialog_visibility,
    setAddCellPhoneModelDialogVisbility,
  ] = useState(false);
  const [add_agent_detail_dialog_visibility, setAddAgentDialogVisbility] =
    useState(false);
  const [carrier, setCarrier] = useState(null);
  const [department, setDepartment] = useState(null);
  const [agent, setAgent] = useState(null);
  const departmentselected = parseLoginRes?.department;

  const [isLoading, setIsLoading] = useState(false);
  const [carrierSelected, setCarrierSelected] = useState("");
  //Make Options
  useEffect(() => {
    if (department === null) {
      api
        .get(`/api/deparments/getDepartments?company=${parseLoginRes.company}`)
        .then((res) => {
          let departmentholder = [];
          for (let i = 0; i < res.data.data.length; i++) {
            const obj = {};
            obj.label = res.data.data[i].departmentName;
            obj.value = res.data.data[i].departmentId;
            departmentholder.push(obj);
          }
          setDepartment(departmentholder);
          // Move this inside the promise callback
        })
        .catch(() => {});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    if (departmentselected !== null) {
      api
        .get(`/api/web/user/getByDepartments?department=${departmentselected}`)
        .then((res) => {
          let agentholder = [];
          for (let i = 0; i < res.data.data.length; i++) {
            const obj = {};
            obj.label = res.data.data[i].name;
            obj.value = res.data.data[i]._id;
            agentholder.push(obj);
          }
          setAgent(agentholder);
        })
        .catch(() => {});
    }
  }, [departmentselected]);
  useEffect(() => {
    api
      .get(`/api/web/carrier/all`)
      .then((res) => {
        let carrierholder = [];
        for (let i = 0; i < res.data.data.length; i++) {
          const obj = {};
          obj.label = res.data.data[i].name;
          obj.value = res.data.data[i]._id;
          carrierholder.push(obj);
        }
        if (carrierholder.length === 1) {
          formik.setFieldValue("carrier", carrierholder[0].value);
          setCarrierSelected(carrierholder[0].label);
        }
        setCarrier(carrierholder);
      })
      .catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const formik = useFormik({
    validationSchema: Yup.object({
      carrier: Yup.string().required("Carrier is Required"),
      SimNumber:
        identifierTypeSelected === "BOTH" || identifierTypeSelected === "ESN"
          ? Yup.string()
              .required("ESN is Required")
              .test("len", "ESN must be the correct length", (value) => {
                if (carrierSelected === "AT&T") {
                  return value && value.length === 20; // 20 characters for AT&T
                } else {
                  return value && value.length === 19; // 19 characters for others
                }
              })
              .matches(/^\d+$/, "IMEI must contain only digits")
          : Yup.string().notRequired(),
      box: Yup.string().required("Box is Required"),
      Model: Yup.string().required("Model is Required"),
      isEsim: Yup.boolean().required("isEsim is Required"),
      IMEI:
        identifierTypeSelected === "BOTH" || identifierTypeSelected === "IMEI"
          ? Yup.string()
              .required("IMEI is Required")
              .test("len", "IMEI must be the correct length", (value) => {
                if (carrierSelected === "AT&T") {
                  return value && value.length === 15; // 20 characters for AT&T
                } else {
                  return value && value.length === 15; // 19 characters for others
                }
              })
              .matches(/^\d+$/, "IMEI must contain only digits")
          : Yup.string().notRequired(),
    }),
    initialValues: {
      carrier: !isUpload ? rowData?.carrier?._id : "",
      serviceProvider: parseLoginRes?.company,
      agentType: parseLoginRes?.department,
      AgentName: parseLoginRes?._id,
      SimNumber: !isUpload ? rowData.simNumber : "",
      box: !isUpload ? rowData.box : "",
      Model: makeModel.substring(makeModel.lastIndexOf("-") + 2),
      unitType: unit,
      make: makeModel.substring(0, makeModel.indexOf("-") - 1),
      inventoryTypeId: inventoryIdSelected,
      billingModel: model,
      Uploaded_by: parseLoginRes?._id,
      IMEI: !isUpload ? rowData.IMEI : "",
      isEsim: !isUpload ? (rowData?.isEsim ?? false) : false,
    },

    onSubmit: (values, { resetForm }) => {
      setIsLoading(true);
      const dataTosend = {
        ...formik.values,
        inventoryTypeId: inventoryIdSelected,
      };
      if (isUpload) {
        api
          .post(
            isUpload
              ? `/api/web/simInventory/addInventory`
              : `/api/web/simInventory/update?inventoryId=${rowData.id}`,
            dataTosend
          )
          .then((res) => {
            ref.current.show({
              severity: "success",
              summary: "Inventory",
              detail: "Successfully Added",
            });
            resetForm();
            if (carrier.length === 1) {
              formik.setFieldValue("carrier", carrier[0].value);
            }
            setIsLoading(false);
            setTimeout(() => {
              if (!isUpload) setAddUnits(false);
            }, 1000);
          })
          .catch((error) => {
            ref.current.show({
              severity: "error",
              summary: "Inventory",
              detail: error?.response?.data?.msg,
            });
            setIsLoading(false);
          });
      } else {
        api
          .put(
            isUpload
              ? `/api/web/simInventory/addInventory`
              : `/api/web/simInventory/update?inventoryId=${rowData.id}`,
            dataTosend
          )
          .then((res) => {
            ref.current.show({
              severity: "success",
              summary: "Inventory",
              detail: "Inventory Successfully Updated",
            });

            if (carrier.length === 1) {
              formik.setFieldValue("carrier", carrier[0].value);
            }
            setIsLoading(false);
            setTimeout(() => {
              if (!isFromhome) {
                setAddUnits(false);
                setUpdateInventory(false);
              }
            }, 1000);
          })
          .catch((error) => {
            ref.current.show({
              severity: "error",
              summary: "Inventory",
              detail:
                error?.response?.data?.message || "Inventory Updation Failed",
            });
            setIsLoading(false);
          });
      }
    },
  });
  useEffect(() => {
    if (formik.values.carrier !== "" && carrier?.length > 0) {
      const carrierlabel = carrier.find(
        (carrier) => carrier.value === formik.values.carrier
      );
      setCarrierSelected(carrierlabel.label);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formik.values.carrier]);
  return (
    <>
      <form onSubmit={formik.handleSubmit}>
        <div className="flex flex-wrap" style={{ gap: "1.2rem", marginTop: "1.2rem" }}>
          <div className="calendar_fieldaddunit">
            <div className="flex justify-content-between">
              <p className="field_labeladdunit ">
                Carrier <span className="steric">*</span>
              </p>
              {formik.errors.carrier && formik.touched.carrier && (
                <div className="p-error">{formik.errors.carrier}</div>
              )}
            </div>
            <Dropdown
              value={formik.values.carrier}
              options={carrier}
              optionLabel="label"
              name="carrier"
              optionValue="value"
              onChange={formik.handleChange}
              placeholder="Select an option"
              className="dropdown"
              style={{ width: "32rem" }}
            />
          </div>
          {identifierTypeSelected === "BOTH" ||
          identifierTypeSelected === "ESN" ? (
            <div className="calendar_fieldaddunit">
              <div className="flex justify-content-between">
                <p className="field_labeladdunit ">
                  ESN <span className="steric">*</span>
                </p>
                {formik.errors.SimNumber && formik.touched.SimNumber && (
                  <div className="p-error">{formik.errors.SimNumber}</div>
                )}
              </div>
              <InputText
                keyfilter="int"
                placeholder="ESN"
                maxLength={carrierSelected === "AT&T" ? 20 : 19}
                value={formik.values.SimNumber}
                name="SimNumber"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                className="dropdown"
                style={{ width: "32rem" }}
              />
            </div>
          ) : undefined}

          {identifierTypeSelected === "BOTH" ||
          identifierTypeSelected === "IMEI" ? (
            <div className="calendar_fieldaddunit">
              <div className="flex justify-content-between">
                <p className="field_labeladdunit">
                  IMEI
                  <span className="steric">*</span>
                </p>
                {formik.errors.IMEI && formik.touched.IMEI && (
                  <div className="p-error">{formik.errors.IMEI}</div>
                )}
              </div>
              <InputText
                type="text"
                placeholder="IMEI"
                keyfilter="int"
                maxLength={15}
                value={formik.values.IMEI}
                name="IMEI"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                className="dropdown"
                style={{ width: "32rem" }}
              />
            </div>
          ) : (
            ""
          )}
          <div className="calendar_fieldaddunit">
            <p className="field_labeladdunit">
              Company Name <span className="steric">*</span>
            </p>
            <InputText
              value={parseLoginRes?.companyName}
              name="serviceProvider"
              disabled
              className="dropdown"
              style={{ width: "32rem" }}
            />
          </div>

          <div className="calendar_fieldaddunit">
            <div className="flex justify-content-between">
              <p className="field_labeladdunit">
                Agent Name <span className="steric">* </span>
              </p>
              {formik.errors.AgentName && formik.touched.AgentName && (
                <div className="p-error">{formik.errors.AgentName}</div>
              )}
            </div>
            <Dropdown
              disabled
              value={formik.values.AgentName}
              options={agent}
              onChange={(e) => formik.setFieldValue("AgentName", e.value)}
              placeholder="Select an option"
              className="dropdown"
              style={{ width: "32rem" }}
            />
          </div>
          <div className="calendar_fieldaddunit">
            <div className="flex justify-content-between">
              <p className="field_labeladdunit">
                Box No<span className="steric">*</span>
              </p>
              {formik.errors.box && formik.touched.box && (
                <div className="p-error">{formik.errors.box}</div>
              )}
            </div>
            <InputText
              type="text"
              placeholder="Box No"
              value={formik.values.box}
              name="box"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              className="dropdown"
              style={{ gap: "1.2rem", width: "32rem" }}
            />
          </div>

          <div className="calendar_fieldaddunit">
            <div className="flex justify-content-between">
              <p className="field_labeladdunit">
                isEsim <span className="steric">*</span>
              </p>
              {formik.errors.isEsim && formik.touched.isEsim && (
                <div className="p-error">{formik.errors.isEsim}</div>
              )}
            </div>
            <Dropdown
              value={formik.values.isEsim}
              options={[
                { label: "Yes", value: true },
                { label: "No", value: false },
              ]}
              name="isEsim"
              optionLabel="label"
              optionValue="value"
              onChange={formik.handleChange}
              placeholder="Select an option"
              className="dropdown"
              style={{ width: "32rem" }}
            />
          </div>

          {!isUpload && (
            <div className="calendar_fieldaddunit">
              <p className="field_labeladdunit">
                Status <span className="steric">*</span>
              </p>
              <InputText
                value={rowData?.status === "available" ? "Free" : "in Use"}
                name="serviceProvider"
                disabled
                style={{
                  textTransform: "uppercase",
                  width: "32rem",
                  color:
                    rowData?.status === "available" ? "#F39C12" : "#27AE60",
                }}
                className="dropdown"
              />
            </div>
          )}
        </div>

          <div
            className=" w-full align-items-start flex flex-wrap flex-row justify-content-end"
            style={{ gap: "1.6rem", marginTop: "3.2rem" }}
          >
            <Button
              className="backbtn"
              type="button"
              label="Cancel"
              onClick={() => {
                if (!isFromhome) {
                  setAddUnits(false);
                  setUpdateInventory(false);
                } else {
                  navigate("/manageinventory");
                }
                // setActiveComponent("");
              }}
              style={{ width: "16rem" }}
            />
            <Button
              label="Submit"
              loading={isLoading}
              className="nextbtn"
              type="submit"
              style={{ width: "16rem" }}
            />
          </div>
        </form>
        <Dialog
        visible={add_cellphone_model_dialog_visibility}
        onHide={() => {
          setAddCellPhoneModelDialogVisbility((prev) => !prev);
        }}
      >
        <AddCellPhoneModelDialog agent={"Dummy"} />
      </Dialog>
      <Dialog
        visible={add_agent_detail_dialog_visibility}
        onHide={() => {
          setAddAgentDialogVisbility((prev) => !prev);
        }}
      >
        <AddAgentDetail agent={"Dummy"} />
      </Dialog>
      <Toast ref={ref} />
    </>
  );
}
